import { Identifier } from "react-admin";
import { MetadataAvatarTypeProperty } from "../../utils/types";

// Action Types
export const STORE_METADATA_BATCH = '360SC_RIKUTEC/STORE_METADATA_BATCH';
export const CLEAR_METADATA_CACHE = '360SC_RIKUTEC/CLEAR_METADATA_CACHE';
export const SET_METADATA_LOADING = '360SC_RIKUTEC/SET_METADATA_LOADING';

// Action Interfaces
export interface StoreMetadataBatchAction {
    readonly type: typeof STORE_METADATA_BATCH;
    payload: {
        metadataAvatarType: Identifier;
        properties: MetadataAvatarTypeProperty[];
    };
}

export interface ClearMetadataCacheAction {
    readonly type: typeof CLEAR_METADATA_CACHE;
    payload?: {
        metadataAvatarType?: Identifier;
    };
}

export interface SetMetadataLoadingAction {
    readonly type: typeof SET_METADATA_LOADING;
    payload: {
        metadataAvatarType: Identifier;
        loading: boolean;
    };
}

// Action Creators
export const storeMetadataBatch = {
    action: STORE_METADATA_BATCH,
    fn: (
        metadataAvatarType: Identifier,
        properties: MetadataAvatarTypeProperty[]
    ): StoreMetadataBatchAction => ({
        type: STORE_METADATA_BATCH,
        payload: {
            metadataAvatarType,
            properties
        }
    })
};

export const clearMetadataCache = {
    action: CLEAR_METADATA_CACHE,
    fn: (metadataAvatarType?: Identifier): ClearMetadataCacheAction => ({
        type: CLEAR_METADATA_CACHE,
        payload: metadataAvatarType ? { metadataAvatarType } : undefined
    })
};

export const setMetadataLoading = {
    action: SET_METADATA_LOADING,
    fn: (
        metadataAvatarType: Identifier,
        loading: boolean
    ): SetMetadataLoadingAction => ({
        type: SET_METADATA_LOADING,
        payload: {
            metadataAvatarType,
            loading
        }
    })
};

// Union type for all metadata actions
export type MetadataAction = 
    | StoreMetadataBatchAction 
    | ClearMetadataCacheAction 
    | SetMetadataLoadingAction;
